import { render, staticRenderFns } from "./anchor-title.vue?vue&type=template&id=08844f4f"
import script from "./anchor-title.vue?vue&type=script&lang=js"
export * from "./anchor-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports